import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';

import { getName, getStreamLink } from '../../helpers/Crew';
import { getAvatarUrl } from '../../helpers/User';

const CrewMember = ({ crew }) => {
	const classNames = [
		'crew-member',
		'text-light',
	];
	if (!crew.confirmed) {
		classNames.push('unconfirmed');
	}
	return <Button
		className={classNames.join(' ')}
		href={getStreamLink(crew) || null}
		key={crew.id}
		rel="noreferer"
		variant="outline-twitch"
	>
		<img alt="" src={getAvatarUrl(crew.user)} />
		<span>{getName(crew)}</span>
	</Button>;
};

CrewMember.propTypes = {
	crew: PropTypes.shape({
		confirmed: PropTypes.bool,
		id: PropTypes.number,
		user: PropTypes.shape({
		}),
	}),
};

export default CrewMember;
